'use client';

import { memo } from 'react';
import { Position, WISHLIST_MODAL_ID } from '@headless-workspace/config';
import { SideMenuModal, useModalActions } from '@headless-workspace/core-ui';
import { UpdateWishlistParams, useWishlist, WishlistModal } from '@headless-workspace/domain/common/client';
import { GlowWishlistButton, ModalCommonClasses, PropsWithLocale } from '@headless-workspace/glow-ds';
import { ComponentMemo } from '@headless-workspace/typings';

type SelectorWishlistButtonProps = PropsWithLocale & UpdateWishlistParams;

export const SelectorWishlistButton: ComponentMemo<SelectorWishlistButtonProps> = memo(({
    productId,
    productName,
    parentId,
    locale,
}) => {
    const { addIfAbsentAndOpen } = useModalActions();

    const { shouldAddToWishlist, update: updateWishlist, isProductInWishlist } = useWishlist();

    const updateWishlistHandler = () => {
        if (shouldAddToWishlist) {
            updateWishlist({
                productId,
                parentId,
                productName,
            });
        } else {
            addIfAbsentAndOpen(
                WISHLIST_MODAL_ID,
                SideMenuModal({
                    side: Position.None,
                    map: {
                        default: <WishlistModal productId={productId} locale={locale} />,
                    },
                    className: ModalCommonClasses,
                }),
            );
        }
    };
    return (
        <GlowWishlistButton
            onClick={updateWishlistHandler}
            isInWishlist={isProductInWishlist(productId)}
            type={'button'}
        />
    );
});
